export default __webpack_public_path__ + "static/media/smallCrosses.9ed9ef88.svg";